<script lang="ts">
	import * as firebaseui from "firebaseui";
	import firebase from "@firebase/app";
	import "@firebase/auth";
	import "@firebase/firestore";
	import Tailwindcss from "./Tailwindcss.svelte";
	import ChevronLeft from "svelte-material-icons/ChevronLeft.svelte";
	import ChevronRight from "svelte-material-icons/ChevronRight.svelte";
	import TrashCanOutline from "svelte-material-icons/TrashCanOutline.svelte";
	import EyeOutline from "svelte-material-icons/EyeOutline.svelte";
	import Restart from "svelte-material-icons/Restart.svelte";
	import SvelteTooltip from "svelte-tooltip";
	import { fade } from "svelte/transition";

	interface Song {
		text: string;
		line: number;
		name: string;
		id: string;
		owner: string;
	}

	let currentSong: Song = {} as Song;
	let currentSongId = "";

	$: {
		currentSong =
			songs.filter((v) => v.id === currentSongId)[0] || ({} as Song);
	}

	let viewing = false;

	window.addEventListener("popstate", () => {
		console.log(window.location.pathname.split("/"));
		if (window.location.pathname.split("/")[1] === "view") {
			console.log(window.location.pathname.split("/")[2]);
			currentSongId = window.location.pathname.split("/")[2];
			viewing = true;
		} else {
			viewing = false;
		}
	});

	$: {
		console.log(window.location.pathname.split("/"));
		if (window.location.pathname.split("/")[1] === "view") {
			console.log(window.location.pathname.split("/")[2]);
			currentSongId = window.location.pathname.split("/")[2];
			viewing = true;
		}
	}

	let lineDiv: HTMLDivElement;

	const viewSong = (event, song) => {
		console.log(event);
		if (
			!event.defaultPrevented &&
			event.button === 0 &&
			!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
		) {
			event.preventDefault();
			history.pushState("", "", "/view/" + song.id);
			currentSongId = song.id;
			viewing = true;
		}
	};

	const restartSong = (song) => {
		song.line = 0;
		firebase
			.firestore()
			.collection("songs")
			.doc(song.id)
			.set({
				...song,
			});
	};

	window.addEventListener("keydown", (ev) => {
		if (ev.key === "Escape" && viewing) {
			/* @ts-ignore */
			history.back();
			viewing = false;
			console.log("Here");
		}
	});

	firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

	var ui = new firebaseui.auth.AuthUI(firebase.auth());

	let user = firebase.auth().currentUser;

	let incSong = (song: Song, a: number) => {
		song.line = Math.min(
			Math.max(song.line + a, 0),
			song.text.split("\n").filter((v) => v !== "").length
		);
		firebase
			.firestore()
			.collection("songs")
			.doc(song.id)
			.set({
				...song,
			});
	};

	let songs: Song[] = [];
	firebase.auth().onAuthStateChanged(() => {
		user = firebase.auth().currentUser;
		console.log(user);
		firebase
			.firestore()
			.collection("songs")
			.where("owner", "==", user.uid)
			.onSnapshot((querySnapshot) => {
				songs = [];
				let i = 0;
				querySnapshot.forEach((doc) => {
					let data = doc.data();
					songs.push({
						name: data.name,
						text: data.text,
						id: doc.id,
						line: data.line,
						owner: data.owner,
					});
					i++;
				});
				songs = songs;
			});
	});

	let nameInput: HTMLInputElement;
	let textInput: HTMLTextAreaElement;

	let addingSongErr = "";
	const addSong = () => {
		if (!nameInput.value) {
			addingSongErr = "Name required";
			setTimeout(() => {
				addingSongErr = "";
			}, 4000);
			return;
		}
		if (!textInput.value) {
			addingSongErr = "Song required";
			setTimeout(() => {
				addingSongErr = "";
			}, 4000);

			return;
		}
		if (user) {
			firebase
				.firestore()
				.collection("songs")
				.add({
					name: nameInput.value,
					text: textInput.value.replace("\n\n", "\n"),
					line: 0,
					owner: user.uid,
				});
			addingSongErr = "";
		} else {
			addingSongErr = "Not logged in";
			setTimeout(() => {
				addingSongErr = "";
			}, 4000);
			return;
		}
		nameInput.value = "";
		textInput.value = "";
	};

	const deleteSong = (song) => {
		if (user) {
			firebase.firestore().collection("songs").doc(song.id).delete();
		}
	};

	ui.start("#firebaseui-auth-container", {
		signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
		callbacks: {
			signInSuccessWithAuthResult: function (authResult, redirectUrl) {
				return false;
			},
		},
	});
</script>

<Tailwindcss />
<main class="m-5">
	{#if !user}
		<div id="firebaseui-auth-container" />
	{:else if !viewing}
		<div class="text-2xl w-full">Your Songs</div>
		{#each songs as song}
			<div class="flex w-full flex-col">
				<div class="text-lg">{song.name} (Line {song.line})</div>
				<div class="flex ml-5 items-center text-white">
					<SvelteTooltip tip="Back">
						<button
							class="focus:outline-none rounded-full w-12 flex justify-center items-center h-12 m-1 text-black"
							on:click={() => incSong(song, -1)}
						>
							<ChevronLeft size="1.75rem" />
						</button>
					</SvelteTooltip>
					<SvelteTooltip tip="Advance">
						<button
							class="focus:outline-none rounded-full w-12 flex justify-center items-center h-12 m-1 text-black"
							on:click={() => incSong(song, 1)}
						>
							<ChevronRight size="1.75rem" />
						</button>
					</SvelteTooltip>
					<SvelteTooltip tip="View">
						<a
							class="focus:outline-none rounded-full w-12 flex justify-center items-center h-12 m-1 appearance-none text-black no-underline border"
							href={`/view/${song.id}`}
							on:click={(e) => viewSong(e, song)}
						>
							<EyeOutline size="1.75rem" />
						</a>
					</SvelteTooltip>
					<SvelteTooltip tip="Restart Song">
						<button
							class="focus:outline-none rounded-full w-12 flex justify-center items-center h-12 m-1 text-black"
							on:click={() => restartSong(song)}
						>
							<Restart size="1.75rem" />
						</button>
					</SvelteTooltip>
					<SvelteTooltip tip="Delete Song">
						<button
							class="focus:outline-none rounded-full w-12 flex justify-center items-center h-12 m-1 text-black"
							on:click={() => deleteSong(song)}
						>
							<TrashCanOutline size="1.75rem" />
						</button>
					</SvelteTooltip>
				</div>
			</div>
		{/each}

		<div>
			<div class="text-2xl">Add New Song</div>
			<div class="text-lg">Song Title</div>
			<input class="text-lg" bind:this={nameInput} />
			<div class="text-lg">Song Lyrics</div>
			<textarea bind:this={textInput} />
			<div>
				<button class="rounded text-lg p-2 m-2" on:click={addSong}
					>Add Song</button
				>
			</div>
			{#if addingSongErr !== ""}
				<div
					transition:fade={{ duration: 500 }}
					class="bg-red-600 text-white p-2 rounded"
				>
					Error: {addingSongErr}
				</div>
			{/if}
		</div>
	{:else}
		<div
			class="line table-cell align-middle text-center w-screen h-screen p-10"
		>
			{currentSong?.text?.split?.("\n")?.filter((v) => v !== "")?.[
				currentSong.line
			] ?? ""}
		</div>
	{/if}
</main>

<style>
	:global(body),
	:global(html) {
		padding: 0px;
		margin: 0px;
		overflow: hidden;
	}

	.line {
		font-size: 500%;
		display: table-cell !important;
		overflow: hidden;
	}

	*:focus {
		outline: none;
	}
</style>
